import { render, staticRenderFns } from "./LeadGooseFileModal.vue?vue&type=template&id=6c88351d&scoped=true&"
import script from "./LeadGooseFileModal.vue?vue&type=script&lang=js&"
export * from "./LeadGooseFileModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadGooseFileModal.vue?vue&type=style&index=0&id=6c88351d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88351d",
  null
  
)

export default component.exports